var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoltfill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 75.9300 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3516-30.8594C10.3516-29.1504 11.7188-27.8809 13.4766-27.8809L35.0098-27.8809L23.6816 2.88086C22.0703 7.32422 26.6602 9.7168 29.5898 6.10352L64.502-37.5C65.1855-38.4277 65.5762-39.2578 65.5762-40.2344C65.5762-41.9434 64.2578-43.2129 62.4512-43.2129L40.918-43.2129L52.2461-73.9746C53.9062-78.418 49.2676-80.8105 46.3379-77.1973L11.4258-33.5938C10.7422-32.666 10.3516-31.8359 10.3516-30.8594Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltfill);
export default __webpack_public_path__ + "static/media/bolt.fill.8b4842e2fe986ba4396d127bd49ba302.svg";
export { ForwardRef as ReactComponent };